import { Box, Typography } from "@mui/material";
import React from "react";
import { DateNTime } from "../../utils/dateTime";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { useTranslation } from "react-i18next";

export const wrapperStyles = (darkMode: boolean) => ({
  p: 2,
  display: "flex",
  flex: 1,
  flexDirection: "row",
  alignItems: "center",
  gap: "12px",
  background: darkMode
    ? "linear-gradient(135deg, var(--neutral-900) 0%, var(--neutral-800) 100%)"
    : "linear-gradient(135deg, var(--neutral-50) 0%, var(--neutral-100) 100%)",
  border: darkMode
    ? "1px solid var(--neutral-700)"
    : "1px solid var(--neutral-200)",
  borderRadius: "12px",
  boxShadow: darkMode
    ? "0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)"
    : "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: darkMode
      ? "0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -2px rgba(0, 0, 0, 0.3)"
      : "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    border: darkMode
      ? "1px solid var(--primary-500)"
      : "1px solid var(--primary-600)",
  },
});

export const iconBoxStyles = (darkMode: boolean) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 48,
  minHeight: 48,
  borderRadius: "50%",
  background: darkMode
    ? "linear-gradient(135deg, var(--primary-1000) 0%, var(--primary-900) 100%)"
    : "linear-gradient(135deg, var(--primary-100) 0%, var(--primary-200) 100%)",
  border: `2px solid var(--primary-600)`,
  boxShadow: darkMode
    ? "0 2px 4px rgba(25, 127, 211, 0.4)"
    : "0 2px 4px rgba(99, 102, 241, 0.2)",
});

export const contentStyles = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  textAlign: "left",
};

export const titleStyles = (darkMode: boolean) => ({
  font: "var(--semibold-sm)",
  color: darkMode ? "var(--primary-300)" : "var(--primary-800)",
  fontWeight: 600,
});

const BookingStarted = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const { t } = useTranslation();

  return (
    <Box sx={wrapperStyles(darkMode)}>
      {/* <Box sx={iconBoxStyles(darkMode)}>
        <PlayCircle sx={{ color: "var(--primary-600)", fontSize: 24 }} />
      </Box> */}
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>Session in progress</Typography>
        <Typography
          sx={{
            color: darkMode ? "var(--neutral-300)" : "var(--neutral-500)",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {t("talent")} {notification?.data?.username}{" "}
          {t("has_started_the_session", { ns: "notification" })}.
        </Typography>
        {notification?.data?.booking_date_time && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "var(--primary-300)" : "var(--primary-800)",
            }}
          >
            {t("start")}:{" "}
            {DateNTime.formatUTC(notification?.data?.booking_date_time)}
          </Typography>
        )}
        <Typography
          sx={{
            font: "var(--semibold-xxs)",
            color: darkMode ? "var(--primary-300)" : "var(--primary-800)",
          }}
        >
          {t("card_name")}: <Box component="span">{notification?.title}</Box>
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#9ca3af" : "#64748b",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default BookingStarted;
